// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-col {
  display: grid;
}

.datetime {
  max-width: fit-content;
}

ion-popover {
  --width: auto;
}

ion-item {
  --padding-start: 0px;
  border: 1px solid black;
}

ion-datetime {
  max-width: 100%;
}

.comment-col {
  width: 60px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/game-transactions/game-transactions.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;AACJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ","sourcesContent":[".button-col {\r\n    display: grid;\r\n}\r\n\r\n.datetime {\r\n    max-width: fit-content;\r\n}\r\n\r\nion-popover {\r\n    --width: auto;\r\n}\r\n\r\nion-item {\r\n    --padding-start: 0px;\r\n    border: 1px solid black;\r\n\r\n}\r\n\r\nion-datetime {\r\n    max-width: 100%;\r\n}\r\n\r\n.comment-col {\r\n    width: 60px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
